import { useGetVideoData } from './useGetVideoData';
import { useGetVideoType } from './useGetVideoType';
import { useGetVideoRatio } from './useGetVideoRatio';
import { useMemo } from 'react';
import useCommonProps from '../../../hooks/useCommonProps';
import { useProfile } from '@brg/auth';
export var useGetVideoProps = function (link) {
    var videoData = useGetVideoData(link !== null && link !== void 0 ? link : '');
    var videoType = useGetVideoType(link !== null && link !== void 0 ? link : '');
    var ratio = useGetVideoRatio(link, videoData, videoType);
    var isVideo = useMemo(function () { return ['sc', 'v', 'yt', 'rt'].includes(videoType); }, [videoType]);
    var _a = useCommonProps(), author = _a.author, isEditable = _a.isEditable;
    var profile = useProfile();
    var isMe = (author === null || author === void 0 ? void 0 : author.accountId) === (profile === null || profile === void 0 ? void 0 : profile.accountId);
    var shouldDisplayErrors = isMe || isEditable;
    return {
        videoData: videoData,
        videoType: videoType,
        ratio: ratio,
        isVideo: isVideo,
        shouldDisplayErrors: shouldDisplayErrors
    };
};
//# sourceMappingURL=useGetVideoProps.js.mapimport { useGetVideoData } from './useGetVideoData';
import { useGetVideoType } from './useGetVideoType';
import { useGetVideoRatio } from './useGetVideoRatio';
import { useMemo } from 'react';
import useCommonProps from '../../../hooks/useCommonProps';
import { useProfile } from '@brg/auth';
export var useGetVideoProps = function (link) {
    var videoData = useGetVideoData(link !== null && link !== void 0 ? link : '');
    var videoType = useGetVideoType(link !== null && link !== void 0 ? link : '');
    var ratio = useGetVideoRatio(link, videoData, videoType);
    var isVideo = useMemo(function () { return ['sc', 'v', 'yt', 'rt'].includes(videoType); }, [videoType]);
    var _a = useCommonProps(), author = _a.author, isEditable = _a.isEditable;
    var profile = useProfile();
    var isMe = (author === null || author === void 0 ? void 0 : author.accountId) === (profile === null || profile === void 0 ? void 0 : profile.accountId);
    var shouldDisplayErrors = isMe || isEditable;
    return {
        videoData: videoData,
        videoType: videoType,
        ratio: ratio,
        isVideo: isVideo,
        shouldDisplayErrors: shouldDisplayErrors
    };
};
//# sourceMappingURL=useGetVideoProps.js.map